import React, { useEffect } from "react";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SearchOutlined } from "@ant-design/icons";
import { CircleCheck, Sparkles } from "lucide-react";
import TextArea from "antd/es/input/TextArea";
import FormItem from "components/fields/FormItem";
import { getEmployeeList } from "../../../../../redux/employee/employeeState";

const { Option } = Select;

const EmployeeSelector = ({ }) => {
  const dispatch = useDispatch();
  const employees = useSelector((state) => state.employee.employeeList?.items);
  const pagination = useSelector((state) => state.employee.employeeList?.pagination);
  const requesting = useSelector((state) => state.employee.employeeList?.requesting);


  useEffect(() => {
      dispatch(getEmployeeList({paginate: pagination.per_page}));
    }, [dispatch, pagination.per_page]);

  return (
    <div className="space-y-4">
      <FormItem
        label="Select Employee *"
        name="ema_employee_id"
        rules={[{ required: true, message: "Please select an employee" }]}
      >
        <Select
          showSearch
          loading={requesting}
          placeholder="Choose an employee to nominate"
          optionFilterProp="children"
          optionLabelProp="label"
          suffixIcon={<SearchOutlined />}
          dropdownStyle={{ maxHeight: 300, overflowY: "auto" }}
        >
          {employees?.map((emp) => (
            <Option
              key={emp.emp_id}
              value={emp.emp_user_detail_id}
              label={emp.employee_name}
            >
              <div className="flex flex-col px-2">
                <div className="flex items-center gap-2">
                  <div className="w-4 flex justify-center">
                    <CircleCheck size={16} className="opacity-0" />
                  </div>

                  <div className="flex flex-col">
                    <span>{emp.employee_name}</span>
                    <span className="text-[11px] text-gray-500">
                      {emp.emp_title} • {emp.department_name}
                    </span>
                  </div>
                </div>
              </div>
            </Option>
          ))}
        </Select>
      </FormItem>

      <FormItem
        label="Why are you nominating this person?"
        name="ema_reason"
        rules={[{ required: true, message: "Please provide a reason" }]}
      >
        <TextArea
          maxLength={255}
          placeholder="Describe why this person deserves this award..."
        />
      </FormItem>

      <FormItem
        label="Provide specific examples"
        name="ema_feedback"
        rules={[{ required: true, message: "Please provide examples" }]}
      >
        <TextArea
          maxLength={255}
          placeholder="Share concrete examples of actions, behaviors, or achievements..."
        />
      </FormItem>

      <div className="flex gap-2 rounded-xl border border-blue-200 bg-blue-50 p-4 dark:border-blue-700/20 dark:bg-blue-900/40">
        <div className="p-2">
          <Sparkles className="h-5 w-5 text-blue-600 dark:text-blue-500" />
        </div>
        <div>
          <p className="text-blue-800text-[13px] dark:text-blue-300">Nomination Tips</p>
          <p className="text-blue-700 text-[12px] dark:text-blue-200">
            Be specific and provide measurable examples. Include dates,
            projects, or situations where the nominee demonstrated the award
            criteria.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmployeeSelector;